import { Component, Input } from '@angular/core';
import { FillRateCombination, FillStatus } from '../../models/diagnostic.models';

type SortDir = 'asc' | 'desc';

@Component({
  selector: 'app-fill-rate-table',
  templateUrl: './fill-rate-table.component.html',
  styleUrls: ['./fill-rate-table.component.scss']
})
export class FillRateTableComponent {
  @Input() set combinations(val: FillRateCombination[]) {
    this._combinations = val || [];
    this.updateSorted();
  }

  sortKey = 'fill_rate';
  sortDir: SortDir = 'asc';
  sorted: FillRateCombination[] = [];

  private _combinations: FillRateCombination[] = [];

  readonly columns = [
    { key: 'placement', label: 'Placement' },
    { key: 'store_type', label: 'Store type' },
    { key: 'categorie_id', label: 'Categoría' },
    { key: 'ad_slot', label: 'Ad slot' },
    { key: 'renders_planned', label: 'Planificados' },
    { key: 'renders_delivered', label: 'Entregados' },
    { key: 'fill_rate', label: 'Fill rate' },
    { key: 'fill_status', label: 'Estado' }
  ];

  readonly statusLabels: Record<FillStatus, string> = {
    delivering: 'Delivering',
    exhausted: 'Exhausted',
    no_delivery: 'No delivery',
    no_data: 'No data'
  };

  toggleSort(key: string): void {
    if (this.sortKey === key) {
      this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortKey = key;
      this.sortDir = 'asc';
    }
    this.updateSorted();
  }

  formatFillRate(value: number | null): string {
    if (value === null || value === undefined) {
      return '-';
    }
    return `${(value * 100).toFixed(2)}%`;
  }

  statusClass(status: FillStatus): string {
    const map: Record<FillStatus, string> = {
      delivering: 'frt-badge--green',
      exhausted: 'frt-badge--amber',
      no_delivery: 'frt-badge--red',
      no_data: 'frt-badge--slate'
    };
    return map[status] || 'frt-badge--slate';
  }

  safe(val: any, fallback = '-'): any {
    return val !== null && val !== undefined ? val : fallback;
  }

  private updateSorted(): void {
    const copy = [...this._combinations];
    const key = this.sortKey;
    const dir = this.sortDir;
    copy.sort((a, b) => {
      const av = (a as any)[key];
      const bv = (b as any)[key];
      if (av === null || av === undefined) {
        return 1;
      }
      if (bv === null || bv === undefined) {
        return -1;
      }
      if (typeof av === 'number' && typeof bv === 'number') {
        return dir === 'asc' ? av - bv : bv - av;
      }
      return dir === 'asc'
        ? String(av).localeCompare(String(bv))
        : String(bv).localeCompare(String(av));
    });
    this.sorted = copy;
  }
}
